import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["entries", "pagination"]
  static values = {
    loading: { type: Boolean, default: false },
  }

  connect() {
    this.observer = new IntersectionObserver((entries) => this.handleIntersection(entries), { threshold: 0.1 })
    this.observer.observe(this.paginationTarget)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  handleIntersection(entries) {
    if (this.loadingValue) return
    if (!entries[0].isIntersecting) return

    const nextPageLink = this.paginationTarget.querySelector("a[rel='next']")
    if (!nextPageLink) return

    this.loadingValue = true
    nextPageLink.click()
    this.paginationTarget.remove()
  }
}
